const constants = {
  set: 'CATEGORIES_SET',
};

const set = (types) => ({
  type: constants.set,
  payload: types,
});

const categoriesActions = {
  constants,
  set,
};

export default categoriesActions;
